<template>
  <w-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="onClose">
    <div slot="content">
      <el-row>
        <div class="flowmap-desc mr-b10">
          <ul>
            <li>· 장비명 : <strong>{{ getObjInfoFormat(true) }}</strong></li>
            <li>· IP 주소 : <strong>{{ getObjInfoFormat(false) }}</strong></li>
          </ul>
        </div>
      </el-row>
      <el-row type="flex" justify="end">
        <w-header-search-button @click="showSearchHeader" align="right" class="mr-b10" />
      </el-row>
      <el-table-wrapper
        ref="eventTable"
        class="c-pointer"
        :data="tableData"
        :columns="tableColumns"
        :column-default="columnDefault"
        :total="total"
        :show-custom-header="true"
        :show-search-tool="showSearchTool"
        :pagination="true"
        @condition-change="setTableParameter"
        style="width:100%;"
        remote>
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId" />
        </template>
        <template slot-scope="scope" slot="event-message-slot">
          <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
            동적
          </div>
          <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{scope.row.eventMessage}}</span>
        </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { openFaultAnalysisPopup } from '@/utils/event';
import ChartAPI from '@/api/performance/analysis/analysis-chart';
import WEventlevelCell from '@/components/table/EventlevelCell';

export default {
  name: 'WEventListPopup',
  components: {
    WEventlevelCell,
  },
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      seletedPoint: null,
      columnDefault,
      showSearchTool: false,
      searchParams: [],
      dateSearchparams: [],
      tableData: [],
      tableColumns: [
        {
          prop: 'eventlevelName',
          label: '등급',
          width: 76,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevel',
          remoteProp: 'eventlevelId',
        },
        { prop: 'eventMessage', label: '장애메시지', searchable: true, scopedSlot: 'event-message-slot' },
        { prop: 'checkDatetime', label: '발생시각', width: 160, searchable: true, searchType: 'date', formatter: this.getDateFormatter },
      ],
      total: 0,
      limit: 50,
      start: 0,
    };
  },
  computed: mapGetters(['selectedNode', 'analysisDateParams']),
  methods: {
    getObjInfoFormat(isNameField) {
      if (isNameField) {
        return (isNil(this.selectedNode.obj.objName)) ? EMPTY_TEXT : this.selectedNode.obj.objName;
      }
      if (isNil(this.selectedNode.obj.ipaddressApplytype)) {
        return EMPTY_TEXT;
      }
      return (this.selectedNode.obj.ipaddressApplytype === 'IPv4') ? this.selectedNode.obj.ipaddressIpv4 : this.selectedNode.obj.ipaddressIpv6;
    },
    /**
     * 장애 메시지 클릭 시 해당 이벤트의 관리 대상의 성능운영 > 요약 화면으로 이동한다.
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickEventMessage(row) {
      if (!isNil(this.selectedNode.obj.objId)) {
        openFaultAnalysisPopup(row.seqNumber);
      }
    },
    showSearchHeader() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 시간 선택에 따른 interval 단위 설정
     * @author leesy918
     * @param  {[type]} startDateTime [description]
     * @param  {[type]} endDateTime   [description]
     * @return {[type]}               [description]
     */
    getStatisticType(interval) {
      const gap = interval;
      const DAY3 = 1000 * 60 * 60 * 24 * 3;
      const DAY19 = 1000 * 60 * 60 * 24 * 19;
      const DAY90 = 1000 * 60 * 60 * 24 * 90;

      if (gap > 0 && gap <= DAY3) {
        return 'day';
      } else if (gap > DAY3 && gap <= DAY19) {
        return 'week';
      } else if (gap > DAY19 && gap <= DAY90) {
        return 'month';
      } else if (gap > DAY90) {
        return 'year';
      }
      return 'null';
    },
    /**
     * 테이블 페이징 설정
     * @author leesy918
     * @param  {[type]} value [description]
     */
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.dateSearchParams = value.dateSearchParams;
      this.loadTableData(this.seletedPoint);
    },
    loadTableData(point) {
      this.seletedPoint = point;
      const timeInterval = this.getStatisticType(this.analysisDateParams.endDatetime - this.analysisDateParams.startDatetime);
      const params = {
        startDatetime: point,
        objId: this.selectedNode.obj.objId,
        managetypeId: this.selectedNode.obj.objManagetypeId,
        timeInterval,
        start: this.start,
        limit: this.limit,
        searchParams: this.searchParams,
        dateSearchParams: this.dateSearchParams,
      };
      ChartAPI.getEventList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data.data;
          this.total = response.data.data.total;
        }
      });
    },
    getDateFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    open(point) {
      this.$refs.slidingPopup.visible = true;
      this.loadTableData(point);
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    onClose() {
      this.searchParams = null;
      this.dateSearchParams = null;
      this.showSearchTool = false;
      this.$refs.eventTable.clearFilter();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/popup/EventListPopup.vue